import FJDomRender from './FJDomRender';
import FJArchiveUtil from '../../util/FJArchiveUtil';

class FJDomRenderManager {
    constructor() {
        this._renders = [];
    }

    /**
     * @desc 获取渲染器
     * @param id
     * @return {*}
     */
    getDomRender(id) {
        return this._renders.find(render => render.id === id);
    }

    /**
     * @desc 开始渲染元素
     * @param element
     * @param startTime，元素在故事版的开始时间
     */
    startRenderElement(element, startTime, { exportSize }) {
        let render;

        render = new FJDomRender({ element, exportSize });
        this._renders.push(render);

        render.start(startTime, {
            expandRatio: FJArchiveUtil.getExpandSizeRatio(element),
        });

        return render;
    }

    /**
     * @desc 清空渲染器
     */
    clear() {
        this._renders.forEach(render => {
            render.cancel();
        });
        this._renders = [];
    }

    /**
     * @desc 删除渲染器
     * @param id
     */
    removeRender(id) {
        const index = this._renders.findIndex(render => render.id === id);
        if (index >= 0) {
            this._renders[index].clear();
            this._renders.splice(index, 1);
        }
    }
}

const domRenderManager = new FJDomRenderManager();

export default domRenderManager;
